import React from 'react'
import { Table } from 'react-bootstrap'
import useJobs from '../../../hooks/use-jobs'
import Item from './item'

const JobsList = () => {
    const { jobs } = useJobs()

    const renderJob = (job, key) => (
        <Item
            key={key}
            job={job}
        />
    )

    return (
        <Table striped hover>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Last Run</th>
                    <th>Schedule</th>
                    <th>Next Run</th>
                </tr>
            </thead>
            <tbody>
                {jobs.map(renderJob)}
            </tbody>
        </Table>
    )
}

export default JobsList